if (!customElements.get('collapsible-image-switcher')) {
  class CollapsibleImageSwitcher extends HTMLElement {
    constructor() {
      super();
      this.onToggle = this.onToggle.bind(this);
    }

    connectedCallback() {
      this.mediaContainer = this.querySelector('[data-image-switcher-media]');
      if (!this.mediaContainer) return;

      this.images = this.mediaContainer.querySelectorAll('[data-switcher-image]');
      this.defaultImageId = this.mediaContainer.dataset.defaultImage;

      this.imageIds = new Set();
      this.images.forEach((img) => this.imageIds.add(img.dataset.switcherImage));

      this.accordions = this.querySelectorAll('.accordion collapsible-details');

      this.accordions.forEach((accordion) => {
        const details = accordion.querySelector('details');
        if (!details) return;

        const observer = new MutationObserver(() => this.onToggle());
        observer.observe(details, { attributes: true, attributeFilter: ['open'] });
        accordion._switcherObserver = observer;
      });

      this.onToggle();
      this.preloadImages();
    }

    preloadImages() {
      const load = () => {
        this.images.forEach((container) => {
          container.querySelectorAll('img[loading="lazy"]').forEach((img) => {
            img.loading = 'eager';
          });
        });
      };

      if ('requestIdleCallback' in window) {
        requestIdleCallback(load);
      } else {
        setTimeout(load, 200);
      }
    }

    onToggle() {
      let activeImageId = null;

      this.accordions.forEach((accordion) => {
        const details = accordion.querySelector('details');
        if (details && details.hasAttribute('open')) {
          const blockId = accordion.closest('.accordion').dataset.blockId;
          if (blockId && this.imageIds.has(blockId)) {
            activeImageId = blockId;
          }
        }
      });

      this.showImage(activeImageId || this.defaultImageId);
    }

    showImage(imageId) {
      this.images.forEach((img) => {
        img.classList.toggle('is-active', img.dataset.switcherImage === imageId);
      });
    }

    disconnectedCallback() {
      if (this.accordions) {
        this.accordions.forEach((accordion) => {
          if (accordion._switcherObserver) {
            accordion._switcherObserver.disconnect();
          }
        });
      }
    }
  }

  customElements.define('collapsible-image-switcher', CollapsibleImageSwitcher);
}
